// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IHomeNewsGetAllAttrs,
  IHomeNewsGetAttrs,
  IHomeNewsSaveAttrs,
} from 'interfaces/back-office/content-management/home/news/home-news-view.interface'

const useNews = () => {
  // Hook
  const {
    homeNews: {
      homeNews_isLoading,
      homeNews_isSaveLoading,
      homeNews_list,
      homeNews_detail,
      homeNews_CLEAR_HOME_NEWS_LIST,
      homeNews_CLEAR_HOME_NEWS,
      homeNews_fetchHomeNewsList: homeNewsFetchList,
      homeNews_fetchHomeNewsDetail: homeNewsFetchDetail,
      homeNews_saveHomeNews: homeNewsSave,
    },
  } = useStores()

  /**
   * @description Get home news list
   *
   * @param {IHomeNewsGetAllAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const homeNews_fetchHomeNewsList = useCallback(
    (payload: IHomeNewsGetAllAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        homeNewsFetchList({
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Get single home news
   *
   * @param {IHomeNewsGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const homeNews_fetchHomeNewsDetail = useCallback(
    (payload: IHomeNewsGetAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        homeNewsFetchDetail({
          params: payload.params,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Save home news
   *
   * @param {IHomeNewsSaveAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const homeNews_saveHomeNews = useCallback(
    (payload: IHomeNewsSaveAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        homeNewsSave({
          params: payload.params,
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    homeNews_isLoading,
    homeNews_isSaveLoading,
    homeNews_list,
    homeNews_detail,
    homeNews_CLEAR_HOME_NEWS_LIST,
    homeNews_CLEAR_HOME_NEWS,
    homeNews_fetchHomeNewsList,
    homeNews_fetchHomeNewsDetail,
    homeNews_saveHomeNews,
  }
}

export { useNews }
